import React, { useState } from "react";
const ProjectVintage = ({ selectedProjectVintage, onSelectProjectVintage }) => {
  return (
    <div className="pb-2  ml-3 mb-2">
      <select
        id="category"
        value={selectedProjectVintage}
        onChange={onSelectProjectVintage}
        className="bg-white w-full text-xs text-grey-700 py-1 pl-3 leading-normal font-normal border border-gray-300 rounded-lg focus:outline-none "
      >
        <option value="" hidden >Select the Year </option>
        <option value="year1">2021</option>
        <option value="year2">2022</option>
        <option value="year3">2022</option>
      </select>
    </div>
  );
};
export default ProjectVintage;
